import { render, staticRenderFns } from "./iconWarranty.vue?vue&type=template&id=a32fcb02&scoped=true"
import script from "./iconWarranty.vue?vue&type=script&lang=js"
export * from "./iconWarranty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32fcb02",
  null
  
)

export default component.exports